import {
  Form,
  Input,
  InputNumber,
  Button,
  Switch,
  Row,
  Col,
  Divider,
  DatePicker,
  message,
  Spin,
  Radio,
  Steps,
  Typography,
} from "antd";
import {
  UserOutlined,
  SolutionOutlined,
  LoadingOutlined,
  SmileOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import UpdateProfile from "./profile";
import SelectHotel from "./selectHotel";
import Nomination from "./addNomination";
import MemberLayout from "../../layout/memberLayout";
const { Title } = Typography;

const { Step } = Steps;
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };
const Onboarding = (props) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {}, []);

  const goPrevious = () => {
    setCurrentStep(currentStep - 1);
  };
  const goNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const showFormContent = () => {
    switch (currentStep) {
      case 0:
        return <UpdateProfile setCurrentStep={() => goNext()} {...props} />;
      case 1:
        return (
          <SelectHotel
            goPrevious={() => goPrevious()}
            setCurrentStep={() => goNext()}
            {...props}
          />
        );
      case 2:
        return navigate("/member/nomination/add");
      default:
    }
  };

  return (
    <Row
      gutter={gutterLayout}
      style={{
        backgroundColor: "white",
        marginTop: "40px",
        padding: "3rem 1rem",
      }}
    >
      <Title level={4}>Complete your profile</Title>
      <Steps current={currentStep}>
        <Step title="Update Profile" icon={<UserOutlined />} />
        <Step title="Select Hotel(s)" icon={<SolutionOutlined />} />
        <Step title="Start nominations" icon={<SmileOutlined />} />
      </Steps>

      <Col style={{ margin: "2rem auto" }}>{showFormContent()}</Col>
    </Row>
  );
};

export default Onboarding;
